import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { skipToken } from "@reduxjs/toolkit/query";
import { signupApi } from "apis/eduidSignup";
import { CommonToU } from "components/Common/CommonToU";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { signupSlice } from "slices/Signup";
import { ServiceInfo } from "./SignupInfo";
import { SignupStepIndicator } from "./SignupStepIndicator";
export function SignupToU() {
    const signupState = useAppSelector((state) => state.signup.state);
    const version = signupState === null || signupState === void 0 ? void 0 : signupState.tou.version;
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (signupState === null || signupState === void 0 ? void 0 : signupState.tou.completed) {
            dispatch(signupSlice.actions.setNextPage("SIGNUP_ENTER_CODE"));
        }
    }, [signupState, dispatch]);
    function handleAccept() {
        dispatch(signupSlice.actions.setNextPage("PROCESS_TOU"));
    }
    function handleCancel() {
        dispatch(signupSlice.actions.setNextPage("SIGNUP_ENTRY"));
    }
    return (_jsxs("div", { className: "step-container", children: [_jsxs("section", { className: "intro", children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "common.createEduidConfirm", defaultMessage: "Create eduID: Confirm/Accept", description: "Terms of use (heading)" }) }), _jsx(ServiceInfo, {}), _jsx("div", { className: "lead", children: _jsx("p", { children: _jsx(FormattedMessage, { id: "tou.lead", defaultMessage: "To create your eduID account you need to accept the eduID terms of use.", description: "Terms of use (lead text)" }) }) })] }), version && _jsx(CommonToU, { version: version, handleAccept: handleAccept, handleCancel: handleCancel }), _jsx(SignupStepIndicator, { currentStep: 2 })] }));
}
export function ProcessToU() {
    const signupState = useAppSelector((state) => state.signup.state);
    const dispatch = useAppDispatch();
    const version = signupState === null || signupState === void 0 ? void 0 : signupState.tou.version;
    const { isSuccess, isError } = signupApi.useAcceptToURequestQuery(version ? { version } : skipToken);
    useEffect(() => {
        if (isSuccess) {
            dispatch(signupSlice.actions.setNextPage("REGISTER_EMAIL"));
        }
        else if (isError) {
            dispatch(signupSlice.actions.setNextPage("SIGNUP_ENTRY"));
        }
    }, [isSuccess, isError, dispatch]);
    return null;
}
